import { combineReducers } from 'redux';

import modal from './ui/modal';

import selectedDataTableModal from './ui/selectedDataModal';

import tabs from './ui/tabs';

import tabsVertical from './ui/tabsVertical';

import roidOTSelected from './ui/roidOTSelectedGeneralView';

import actionTabs from './ui/actionTabs';

import cursorTables from './ui/cursorTables';

import tablePages from './ui/tablePages';

import takeTables from './ui/takeTables';

import loadingData from './ui/loadingData';

import language from './language';

import orderCloseConfirmation from './ui/orderCloseConfirmation';

import orderFlags from './orderFlags';

export default combineReducers({
  modal,
  selectedDataTableModal,
  tabs,
  tabsVertical,
  roidOTSelected,
  actionTabs,
  cursorTables,
  tablePages,
  takeTables,
  loadingData,
  language,
  orderCloseConfirmation,
  orderFlags,
});
